export default "__VITE_ASSET__B$SbtPyF__"